import { OccConfig } from '@spartacus/core';

export const defaultOccAsmConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        asmCustomerSearch: '/assistedservicewebservices/customers/search',
        asmCustomerImpersonationSearch: '/py/impersonation/customers/search',
      },
    },
  },
};
